var payment4i = function () {
	"use strict";

	var RegistrationForm = new RegistrationFormPanel();
	var tooltips = new toolTips();
	var forms = new forms4i();
	var accordions = new getAccordions4i();
	var windowWidth = window.innerWidth;
	var jsMessages = {};
	var paymentMethodEditMode = false;
	var updatedBillingAddresses, creditCardIds, triggerEl;
	var authenticationLayer, confirmDeleteDialog;
	var kaID;

	var init = function () {
		formEvents.CheckIfSmallScreen();
		formEvents.CheckCartHasCoupon();
		formEvents.BindPaymentMethodEvents();
		formEvents.SetRegisterUserForm();

		accordions.init(document.getElementById("mainContent"));
		if (document.getElementById("orderSummaryBody")) {
			updateAccordionCSS();
			tooltips.init(); // tax exempt tooltip
		}
		deleteDialog.Init();
		if (document.getElementById("divNewPaymentMethod")) formEvents.NewCreditCard();

		//not actually programmed for yet...
		var extraChargeBtns = [].slice.call(document.querySelectorAll(".cartDetailsBtn"));
		extraChargeBtns.forEach(function (el, index, array) {
			el.addEventListener("click", function (e) {
				e.preventDefault();
				triggerEl = el;
				formEvents.ShowDetailsPopup(el);
			});
		});

		const editPay = document.getElementById("editPaymentMethod");
		if (editPay) {
			editPay.addEventListener("click", function (e) {
				paymentMethodEditMode = true;
			});
		}

		const authenticate = document.getElementById("AuthenticationRequired");
		if (authenticate && authenticate.value == 'True') {
			const sessionId = document.getElementById('UserCart_SessionID').value;
			const orderId = document.getElementById("UserCart_OrderGuid").value;
			const transactionId = document.getElementById("UserCart_TransactionID").value;
			const merchantId = document.getElementById("MerchantID").value;
			if (typeof authenticationLayer4i !== 'undefined') {
				authenticationLayer4i.Init(orderId, 2, sessionId, transactionId, merchantId, formEvents.ShowAuthenticationError);
				authenticationLayer = authenticationLayer4i;
			}
		}
		const kaElement = document.getElementById('KaID');
		//feature flag
		if (kaElement) {
			kaID = kaElement.value;
			const kaENV = kaElement.getAttribute('data-env');

			let kountConfig = {
				clientID: 300807,
				environment: kaENV,
				isSinglePageApp: false,
				isDebugEnabled: kaENV == 'TEST'
			};

			const kount = kountSDK(kountConfig, kaID);
			if (kount && kaENV == 'TEST') console.log('Kount SDK loaded');
		}

	},

		deleteDialog = (function () {
			let init = () => {
				confirmDeleteDialog = new Dialog4i();
				confirmDeleteDialog.Init({
					triggerElements: [].slice.call(document.querySelectorAll(".btnDeleteCC")),
					dialogClass: "smallDialog",
					title: "Delete?",
					content: getContent(),
					onOpen: open,
					onClose: close
				});
			},
				getContent = () => {
					return '<div class="displayFlex flexJustifyEnd flexAlignItemsCenter">' +
						'<button id="btnConfirmCancel" class="close4iDialog btnToHyp underline text16 marginRight20" type="button">Cancel</button>' +
						'<button id="btnConfirmDelete" class="button-md bkgdBlue text16" type="button">Delete</button>' +
						'</div>';
				},
				open = (el) => {
					formEvents.CloseOpenEditsCC();
					forms.ClearValidation();
					formEvents.ShowBusy(el.parentNode);

					const dialog = document.getElementById("popUpDialog");
					const ccId = el.getAttribute("data-card-id");
					if (ccId) {
						const header = document.getElementById("DeleteCreditCardLabel").value;
						dialog.querySelector('h2').innerHTML = header;
						dialog.setAttribute("data-delete-type", "CC");
						dialog.setAttribute("data-card-id", ccId);
					}
					const deleteBtn = document.getElementById("btnConfirmDelete");
					deleteBtn.addEventListener("click", formEvents.DeleteConfirmed);
				},
				close = () => {
					formEvents.HideBusy();
				};
			return {
				Init: init
			};
		})(),

		updateAccordionCSS = function () { //hack so the tooltip will not be cut off by the overflow hidden on accordion panel
			var orderSumAccordion = document.getElementById("orderSummaryBody");
			if (orderSumAccordion.classList.contains("open")) {
				orderSumAccordion.style.overflow = "visible";
			}
			document.getElementById("orderSummaryHeader").querySelector("button").addEventListener("click", function (e) {
				if (orderSumAccordion.getAttribute("aria-hidden") == "false") {
					orderSumAccordion.style.overflow = "visible";
				} else {
					orderSumAccordion.style.overflow = "hidden";
				}
			});
		},

		ajaxActions = (function () {
			var verificationToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0] ? document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value : "",
				cartId = document.getElementById("UserCart_CartID"),

				getMessages = (function () {
					// ajax call to get error messages

					fetch('/cart/javascriptMessages/cart', {
						method: 'GET',
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						jsMessages = response;
					}).catch(function (error) {
						jsMessages = {
							"deleteFailed": "Could not delete item from cart. Refresh page and try again.",
							"couponError": "Oops! The coupon code is not valid. Please Try Again.",
							"deleteCouponError": "Could not delete coupon from cart. Refresh page and try again.",
							"clearCartError": "Could not clear cart. Refresh page and try again.",
							"getItemDetailsError": "Could not retrieve item details. Refresh page and try again.",
							"setPaymentMethodError": "Could not update payment method. Refresh page and try again.",
							"updateFreightError": "Could not update freight option. Refresh page and try again.",
							"updateShippingAddressError": "Could not update shipping address. Refresh page and try again.",
							"submitOrderError": "Could not submit order. Refresh page and try again.",
							"deleteCCError": "Could not delete the card. Refresh page and try again.",
							"creditCardNotSaved": "There was an error saving payment information. Please try again.",
							"updateBillingAddressError": "Could not update billing address. Refresh page and try again.",
							"parseFreightOptionError": "Invalid cart item or ship method passed. Refresh page and try again.",
							"getCCFormError": "<span class='textBold textRed'>Error Getting Card Form</span>",
							"getAddressFormError": "<span class='textBold textRed'>Error Getting Address Form</span>",
							"invalidAddressError": "Invalid address, please select a different address.",
							"invalidNameError": "Name is invalid, please select a different address.",
							"invalidCityError": "Invalid city, please select a different address.",
							"invoicePaymentLabel": "<p id='#divPaymentMethod_000' class='padding5'>You have chosen to pay with an invoice.</p>",
							"getCreditCardIds": "Could not get accepted card types. Refresh page and try again.",
							"missingShipAddress": "Missing shipping address, please click Use Address next to correct address or Add a new address.",
							"authenticationError": "There was an authentication error. Please try again or use a different payment method."
						};
					});
				})(),
				getCreditCardIds = (function () { // get a list of Credit Card Ids 
					fetch('/checkout/GetPaymentTypes', {
						method: 'GET',
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						creditCardIds = response;
					}).catch(function (error) {
						formEvents.ShowAjaxMessage(jsMessages.getCreditCardIds);
					});
				})(),

				getCCForm = function (container, callBack) {
					// get blank cc form
					fetch('/payment/ccform', {
						method: 'GET',
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
					}).then(function (response) {
						return (response.ok) ? response.text() : [];
					}).then(function (response) {
						if (container != "") {
							container.innerHTML = response;
						}
						document.getElementsByClassName("divCancelSaveAddress")[0].classList.add("hide");
						document.getElementsByClassName("divCancelSaveAddress")[0].classList.remove("inlineMiddle");
						document.getElementsByClassName("cancelEdit")[0].classList.add("hide");
						document.getElementsByClassName("cancelEdit")[0].classList.remove("button-md");
						if (document.getElementById("divRegisteredUser").classList.contains("hide")) {
							document.getElementById("divSaveAddressBtn").classList.add("hide");
							document.getElementById("divSaveAddressBtn").classList.remove("inlineMiddle");
						}
						callBack();
					}).catch(function (error) {
						if (container != "") {
							if (jsMessages.getCCFormError === undefined) {
								container.innerHTML = "We're sorry, an error has occurred.  Please refresh the page and try again.";
							}
							else {
								container.innerHTML = jsMessages.getCCFormError;
							}
						}
						formEvents.HidePaymentLoad();
					});
				},

				getExtraDetails = function (line) {
				},

				deleteCC = function (cardId) {
					confirmDeleteDialog.Close();
					formEvents.LoadPayment();
					let data = { cardId: cardId };
					fetch('/payment/deletecreditcard', {  // update to checkout when migrated
						method: 'POST',
						body: JSON.stringify(cardId),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken, "__RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						if (response.Success) {
							formEvents.RemoveCreditCard(cardId);
							var savedPayments = document.getElementById("PaymentMethods_Count") ? document.getElementById("PaymentMethods_Count").value : document.getElementById("PaymentMethods_Count").value;
							if (parseInt(savedPayments) === 1) {
								savedPayments = 0;
								document.getElementById("PaymentMethods_Count").value = savedPayments;
								formEvents.ShowPaymentMethodPanel();
							} else {
								formEvents.HidePaymentLoad();
								savedPayments = parseInt(savedPayments) > 1 ? parseInt(savedPayments) - 1 : 1;
								document.getElementById("PaymentMethods_Count").value = savedPayments;
							}
						} else {
							formEvents.ShowAjaxMessage(response.Message);
							formEvents.HidePaymentLoad();
						}
					}).catch(function (error) {
						formEvents.HidePaymentLoad();
						formEvents.ShowAjaxMessage(jsMessages.deleteCCError);
					});
				},

				savePaymentMethod = function (creditCard) {
					var authentication = { TransactionId: 0 };
					if (authenticationLayer && document.getElementById('userEmail').value != "siteimprove@4imprint.com") {
						authentication = authenticationLayer.GetAuthenticationResponse(creditCard);
						if (authentication.TransactionId == 0) {
							var amount = document.getElementsByClassName("cartTotal")[0].innerText.replace(/[^0-9.-]+/g, "");
							var emailForm = document.getElementById("emailFormBlock");
							var email = emailForm.querySelector("#BillingEmail").value;
							authenticationLayer.Authenticate(creditCard, amount, savePaymentMethod, [creditCard], email);
							return;
						}
					}

					let data = {
						Payment: creditCard,
						OasisOrderId: parseInt(document.getElementById("Cart_UserCart_OasisOrderID").value),
						CartTotal: parseFloat(document.getElementById("Cart_UserCart_CartTotal").value),
						KaptchaSessionId: document.getElementById("KaID") ? document.getElementById("KaID").value : "",
						AuthenticationResponse: authentication,
						Email: document.getElementById("BillingEmail").value
					};
					fetch('/payment/SavePaymentMethod', {
						method: 'POST',
						body: JSON.stringify(data),
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken, "__RequestVerificationToken": verificationToken }
					}).then(function (response) {
						return (response.ok) ? response.json() : [];
					}).then(function (response) {
						formEvents.HidePaymentLoad();

						if (typeof response.Success !== 'undefined' && response.Success) {
							document.getElementsByClassName("paymentTotalHeader")[0].classList.add("hide");
							document.getElementsByClassName("paymentTotalHeader")[0].classList.remove("inlineMiddle");
							document.getElementById("divPaymentMethod").querySelector("h2").classList.add("hide");
							document.getElementById("headerPanelText").classList.add("hide");
						
							if (document.getElementById('Cart_IsRegistered').value != "True") {
								RegistrationForm.SetForm_RegisterUser(response.PartialView2);
								formEvents.DisplaySuccessPage(response.PartialView1, false);
								document.getElementById("paymentAmount").innerHTML = document.getElementsByClassName("paymentTotalAmount")[0].innerHTML;
								forms.BindPasswordButtons();
							} else {
								formEvents.DisplaySuccessPage(response.PartialView1, true);
								document.getElementById("paymentAmount").innerHTML = document.getElementsByClassName("paymentTotalAmount")[0].innerHTML;
								document.getElementById("signedInPanel").classList.add("hide");
								document.getElementById("signedInPanel").classList.remove("inlineMiddle");
							}
						} else {
							if (authenticationLayer) {
								authenticationLayer.RemoveCard(creditCard);
							}

							if (typeof response.PartialView1 !== 'undefined' && response.PartialView1 !== "x" && response.PartialView1 !== "") {
								document.getElementsByClassName("form2018")[0].insertAdjacentHTML('afterbegin', response.PartialView1);
								document.getElementById("divPaymentMethod").focus();
								document.getElementById("divPaymentMethod").scrollIntoView({ top: 0, behavior: "smooth" });
							}
							else {
								if (typeof response.Message !== 'undefined') {
									document.getElementById("divCreditCardFormBlock").querySelector(".infoText").innerHTML = response.Message;
								}
								else {
									document.getElementById("divCreditCardFormBlock").querySelector(".infoText").innerHTML = "We're sorry, an error has occurred. Please refresh the page and try again.";
								}
								forms.serverValidation(document.getElementById("divCreditCardFormBlock").querySelector(".infoText"));
								
								if (document.getElementById("divCreditCardFormBlock").querySelector(".infoText").querySelector("a")) {
									document.getElementById("divCreditCardFormBlock").querySelector(".infoText").querySelector("a").focus();
								}
								document.getElementById("divCreditCardFormBlock").scrollIntoView({ top: 0, behavior: "smooth" });
							}
						}
					}).catch(function (error) {
						formEvents.HidePaymentLoad();
						document.getElementById("divCreditCardFormBlock").querySelector(".infoText").innerHTML = jsMessages.creditCardNotSaved;
						document.getElementById("CardName").focus();
						document.getElementById("divCreditCardFormBlock").scrollIntoView({ top: 0, behavior: "smooth" });
					});
				};

			return {
				GetExtraDetails: getExtraDetails,
				DeleteCC: deleteCC,
				SavePaymentMethod: savePaymentMethod,
				GetCCForm: getCCForm
			};
		}()),

		omniture = (function () {
			const account = typeof s_account === 'string' ? s_account : '4imprintprod';
			const s = typeof s_gi === 'function' ? s_gi(account) : '';

			var addCouponCode = function (couponCode) {
				if (s) {
					var sc = s_gi(account);
					sc.linkTrackVars = 'eVar5,events';
					sc.linkTrackEvents = 'event2';
					sc.eVar5 = couponCode;
					sc.events = 'event2';
				}
			},
				shipMethod = function () {
					if (s) {
						s.events = "event10";
						s.t();
					}
				},
				payMethod = function () {
					if (s) {
						s.events = s.getValOnce("event5", "event_5_pymt");
						s.t();
					}
				};
			return {
				AddCouponCode: addCouponCode,
				ShipMethod: shipMethod,
				PayMethod: payMethod
			};
		}()),

		addressMethods = (function () {
			var billingAddressTypeId = 0,

				blankAddress = function () {
					return {
						AddressId: "",
						FirstName: "",
						LastName: "",
						CompanyName: "",
						Address1: "",
						Address2: "",
						City: "",
						State: "",
						ZipCode: "",
						Phone: "",
						Default: false,
						Active: true,
						AddressType: 0,
						LinkedAddress: false
					};
				},

				getExistingAddress = function (element, type, ignoreErrors) {
					var a = document.querySelector(element).querySelectorAll("p");
					if (a.length < 10) {
						if (!ignoreErrors) formEvents.ShowAjaxMessage(jsMessages.invalidAddressError);
						return null;
					}

					var name = a[1].innerHTML.split("&nbsp;");
					if (name.length < 2) {
						if (!ignoreErrors) formEvents.ShowAjaxMessage(jsMessages.invalidNameError);
						return null;
					}

					var cityStateZip = a[5].innerHTML.split("&nbsp;");
					if (cityStateZip.length < 3 || cityStateZip[0].length < 2) {
						if (!ignoreErrors) formEvents.ShowAjaxMessage(jsMessages.invalidCityError);
						return null;
					}

					var addressObject = blankAddress();
					addressObject.AddressId = a[0].textContent.trim();
					addressObject.FirstName = name[0] ? name[0] : "";
					addressObject.LastName = name[1] ? name[1] : "";
					addressObject.CompanyName = a[2].textContent;
					addressObject.Address1 = a[3].textContent;
					addressObject.Address2 = a[4].textContent;
					addressObject.City = cityStateZip[0].length - 1 > 0 ? cityStateZip[0].substring(0, cityStateZip[0].length - 1) : "";
					addressObject.State = cityStateZip[1];
					addressObject.ZipCode = cityStateZip[2];
					addressObject.Phone = a[6].textContent;
					addressObject.Default = a[7].textContent.toLowerCase() === "true";
					addressObject.Active = a[8].textContent.toLowerCase() === "true";
					addressObject.LinkedAddress = a[9].textContent.toLowerCase() === "true";
					addressObject.AddressType = type;

					return addressObject;
				},

				fillEditBillingAddress = function () {
					var address = addressMethods.GetExistingAddress("#divBillAddress", billingAddressTypeId);
					if (address === null) {
						address = blankAddress();
					}
					fillForm(document.getElementById("divAddressFormBlock"), address);
				},

				fillForm = function (form, address) {
					form.querySelector("#AddressId").value = address.AddressId;
					form.querySelector("#FirstName").value = address.FirstName;
					form.querySelector("#LastName").value = address.LastName;
					form.querySelector("#CompanyName").value = address.CompanyName;
					form.querySelector("#Address1").value = address.Address1;
					form.querySelector("#Address2").value = address.Address2;
					form.querySelector("#City").value = address.City;
					form.querySelector("#State").value = address.State;
					form.querySelector("#ZipCode").value = address.ZipCode;
					form.querySelector("#Phone").value = removeNonNumeric(address.Phone);
					form.querySelector("#Default").checked = address.Default;
					form.querySelector("#Active").value = address.Active;
					form.querySelector("#LinkedAddress").value = address.LinkedAddress;

					forms.MaskPhoneNumber(document.getElementById("PhoneMask"), document.getElementById("Phone"));
				},

				removeNonNumeric = function (value) {
					return value.replace(/\D/g, '');
				},

				selectBillingAddress = function (element) {
					var selectAddress = element.querySelectorAll("p");
					var billAddress = document.getElementById("divBillAddress").querySelectorAll("p");

					if (selectAddress.length === billAddress.length) {
						for (var i = 0; i < selectAddress.length; i++) {
							billAddress[i].innerHTML = selectAddress[i].innerHTML;
						}
					} else {
						document.getElementById("divCreditCardFormBlock").querySelector(".infoText").innerHTML = jsMessages.invalidAddressError;
						document.getElementById("CardName").focus();
						document.getElementById("divCreditCardFormBlock").scrollIntoView({ top: 0, behavior: "smooth" });
					}
				},

				getNewBillingAddress = function () {
					return createAddressObject(document.getElementById("divAddBillAddress"), billingAddressTypeId);
				},

				createAddressObject = function (form, type) {
					var addressObject = blankAddress();
					addressObject.AddressId = form.querySelector("#AddressId").value.trim();
					addressObject.FirstName = form.querySelector("#FirstName").value;
					addressObject.LastName = form.querySelector("#LastName").value;
					addressObject.CompanyName = form.querySelector("#CompanyName").value;
					addressObject.Address1 = form.querySelector("#Address1").value;
					addressObject.Address2 = form.querySelector("#Address2").value;
					addressObject.City = form.querySelector("#City").value;
					addressObject.State = form.querySelector("#State").value;
					addressObject.ZipCode = form.querySelector("#ZipCode").value;
					addressObject.Phone = form.querySelector("#Phone").value;
					addressObject.Default = form.querySelector("#Default").checked = true;
					addressObject.Active = form.querySelector("#Active").value.toLowerCase() === "true";
					addressObject.LinkedAddress = form.querySelector("#LinkedAddress").value.toLowerCase() === "true";
					addressObject.AddressType = type;

					return addressObject;
				},

				fillNewBillingAddress = function (address) {
					var billAddress = document.getElementById("divBillAddress").getElementsByTagName("p");
					copyBillingAddress(billAddress, address);
				},

				updateSelectedBillingAddressOnChange = function (address) {
					if (address && document.getElementById("ccAddressSelected")) {
						var billAddress = document.getElementById("ccAddressSelected").querySelectorAll("p");
						if (address.AddressId === billAddress[0].textContent.trim()) {
							copyBillingAddress(billAddress, address);
						}
					}
				},

				copyBillingAddress = function (billAddress, address) {
					billAddress[0].innerHTML = address.AddressId;
					billAddress[1].innerHTML = address.FirstName + "&nbsp;" + address.LastName;
					billAddress[2].innerHTML = address.CompanyName;
					billAddress[3].innerHTML = address.Address1;
					billAddress[4].innerHTML = address.Address2;
					billAddress[5].innerHTML = address.City + ",&nbsp;" + address.State + "&nbsp;" + address.ZipCode;
					billAddress[6].innerHTML = address.Phone;
					billAddress[7].innerHTML = address.Default;
					billAddress[8].innerHTML = address.Active;
					billAddress[9].innerHTML = address.LinkedAddress;
				};

			return {
				BlankAddress: blankAddress,
				CopyBillingAddress: copyBillingAddress,
				GetExistingAddress: getExistingAddress,
				FillEditBillingAddress: fillEditBillingAddress,
				get BillingAddressTypeId() { return billingAddressTypeId; },
				SelectBillingAddress: selectBillingAddress,
				GetNewBillingAddress: getNewBillingAddress,
				FillNewBillingAddress: fillNewBillingAddress,
				UpdateSelectedBillingAddressOnChange: updateSelectedBillingAddressOnChange
			};
		}()),

		paymentMethods = (function () {
			var blankCC = function () {
				return {
					Address: addressMethods.BlankAddress(),
					CardCCV: "",
					CardExpirationMonth: "",
					CardExpirationYear: "",
					CardID: "",
					CardName: "",
					CardNumber: "",
					CardPrefix: "",
					PaymentID: "",
					PaymentTypeID: -1,
					SavedName: "",
					IsDefault: false,
					PaymentDescription: "",
					IsSaved: false
				};
			},

				getExistingCC = function (element, ignoreErrors) {
					var a = document.querySelector(element).querySelectorAll("p");
					var ccObject = blankCC();

					ccObject.CardID = a[0].textContent.trim();
					ccObject.PaymentID = a[1].textContent.trim();
					ccObject.PaymentTypeID = parseInt(a[2].textContent);
					ccObject.CardName = forms.VerifyName(a[3].textContent);
					ccObject.PaymentDescription = a[4].textContent;
					ccObject.CardCCV = a[5].textContent;
					ccObject.SavedName = forms.VerifyName(a[6].textContent);
					ccObject.CardNumber = a[7].textContent;

					var expdate = a[8].textContent.split("/");
					ccObject.CardExpirationMonth = expdate[0];
					ccObject.CardExpirationYear = expdate[1];

					ccObject.IsAuthorized = a[9].textContent.toLowerCase() === "true";

					if (a.length < 20) {
						if (!ignoreErrors) formEvents.ShowAjaxMessage(jsMessages.invalidAddressError);
						return ccObject;
					}

					// get cc address
					var ccAddressObject = addressMethods.GetExistingAddress("#ccAddress_" + ccObject.CardID, addressMethods.BillingAddressTypeId);
					if (ccAddressObject === null) {
						return ccObject;
					}

					// look for updated address
					var addressObject = addressMethods.GetExistingAddress("#divBillAddress_" + ccAddressObject.AddressId, addressMethods.BillingAddressTypeId, true);
					var valid = !!addressObject;

					ccObject.Address.FirstName = valid ? addressObject.FirstName : ccAddressObject.FirstName;
					ccObject.Address.LastName = valid ? addressObject.LastName : ccAddressObject.LastName;
					ccObject.Address.CompanyName = valid ? addressObject.CompanyName : ccAddressObject.CompanyName;
					ccObject.Address.Address1 = valid ? addressObject.Address1 : ccAddressObject.Address1;
					ccObject.Address.Address2 = valid ? addressObject.Address2 : ccAddressObject.Address2;
					ccObject.Address.City = valid ? addressObject.City : ccAddressObject.City;
					ccObject.Address.State = valid ? addressObject.State : ccAddressObject.State;
					ccObject.Address.ZipCode = valid ? addressObject.ZipCode : ccAddressObject.ZipCode;
					ccObject.Address.Phone = valid ? addressObject.Phone : ccAddressObject.Phone;
					ccObject.IsDefault = ccAddressObject.Default;
					ccObject.Address.AddressId = ccAddressObject.AddressId;
					ccObject.IsSaved = ccAddressObject.LinkedAddress;

					formEvents.HideAjaxMessage();

					return ccObject;
				},

				fillEditCCForm = function (cardId) {
					var cCard = getExistingCC("#divPaymentMethod_" + cardId);
					var form = document.getElementById("divEditCC_" + cardId);
					fillForm(form, cCard, true);
					tooltips.init();
					form.querySelector('#CardNumber').disabled = true;
					form.querySelector('#IsSaved').disabled = true;

					if (form.querySelector("#divBillAddress").querySelector("p").textContent.length > 0) {
						form.querySelector("#divBillAddress").classList.remove('hide');
						form.querySelector("#divSaveCreditCard").classList.remove('hide');
					}

					forms.MaskCVVNumber(document.getElementById("CvvMask"), document.getElementById("CardCCV"));
				},

				fillEnterCVVForm = function (cardId) {
					var cCard = getExistingCC("#divPaymentMethod_" + cardId);
					var form = document.getElementById("divEditCC_" + cardId);
					fillForm(form, cCard, true);

					forms.MaskCVVNumber(document.getElementById("CvvMask"), document.getElementById("CardCCV"));
					document.getElementById("CardCCV").addEventListener("keydown", function (e) {
						if (e.key === "Enter") {
							document.getElementById("btnSaveCreditCard").click();
						}
					});
				},

				fillNewCCForm = function () {
					var cCard = blankCC();
					var form = document.getElementById("divNewPaymentMethod");
					tooltips.init();
					fillForm(form, cCard);

					if (document.getElementById('Cart_IsRegistered').value == "True") {
						form.querySelector('#IsSaved').checked = true;
						form.querySelector("#IsDefault").checked = true;
					}
					forms.MaskCCNumber(document.getElementById("CreditCardMask"), document.getElementById("CardNumber"));
					forms.MaskCVVNumber(document.getElementById("CvvMask"), document.getElementById("CardCCV"));

				},

				fillForm = function (form, cCard, editing) {
					form.querySelector("#CardID").value = cCard.CardID;
					form.querySelector("#PaymentID").value = cCard.PaymentID;
					form.querySelector("#IsDefault").checked = cCard.IsDefault;
					form.querySelector("#SavedName").value = forms.VerifyName(cCard.SavedName);
					form.querySelector("#IsSaved").checked = cCard.IsSaved;
					form.querySelector("#CardNumber").value = cCard.CardNumber;
					form.querySelector("#PaymentTypeID").value = cCard.PaymentTypeID;
					form.querySelector("#CardExpirationMonth").value = cCard.CardExpirationMonth;
					form.querySelector("#CardExpirationYear").value = cCard.CardExpirationYear;
					form.querySelector("#CardName").value = forms.VerifyName(cCard.CardName);
					form.querySelector("#CardCCV").value = cCard.CardCCV;
					form.querySelector("#IsAuthorized").value = cCard.IsAuthorized;
					form.querySelector("#PaymentDescription").value = cCard.PaymentDescription;

					var billaddress = form.querySelector("#divBillAddress").querySelectorAll("p");
					if (billaddress[0]) {
						addressMethods.CopyBillingAddress(billaddress, cCard.Address);
					}
					forms.MaskPhoneNumber(document.getElementById("PhoneMask"), document.getElementById("Phone"));
				},

				setPaymentMethod = function (element) {
					formEvents.ClearPaymentMethodError();

					var cardId = document.querySelector(element).getAttribute("data-card-id");

					if (formEvents.VerifyCreditCardAuthorized(getExistingCC("#divPaymentMethod_" + cardId))) {
						if (document.getElementById("divSelectPaymentMethod").querySelector("p").textContent === cardId) {
							paymentMethodEditMode = false;
							formEvents.PaymentMethodDefaultMode();
							return;
						}
					} else {
						formEvents.PutCreditCardInEditMode(cardId);
					}
				},

				getEditCC = function (cardId) {
					var form;

					if (cardId.trim().length === 0) {
						form = document.getElementById("divNewPaymentMethod");
					} else {
						form = document.getElementById("divEditCC_" + cardId);
					}

					var ccObject = blankCC();

					ccObject.CardID = form.querySelector("#CardID").value.trim();
					ccObject.PaymentID = form.querySelector("#PaymentID").value.trim();
					ccObject.PaymentTypeID = form.querySelector("#PaymentTypeID").value;
					ccObject.PaymentDescription = form.querySelector("#PaymentDescription").value;
					ccObject.IsAuthorized = form.querySelector("#IsAuthorized").value.toLowerCase() === "true";

					// ignore ccv if not using micro-service
					ccObject.CardCCV = form.querySelector("#CardCCV").getAttribute("type") === "hidden" ? "000" : form.querySelector("#CardCCV").value;

					//if the cardnumber is masked, return the non-masked cardnumber, otherwise just the value
					ccObject.CardNumber = form.querySelector("#CardNumber").value;
					ccObject.CardExpirationMonth = form.querySelector("#CardExpirationMonth").value;
					ccObject.CardExpirationYear = form.querySelector("#CardExpirationYear").value;
					ccObject.CardName = forms.VerifyName(form.querySelector("#CardName").value);
					ccObject.IsDefault = form.querySelector("#IsDefault").checked;
					ccObject.IsSaved = form.querySelector("#IsSaved").checked;

					ccObject.SavedName = ccObject.IsSaved && form.querySelector("#SavedName").value ? forms.VerifyName(form.querySelector("#SavedName").value) : forms.GetCreditCardName(ccObject.CardNumber);

					if (cardId.trim().length === 0 || !document.getElementById("divAddBillAddress").classList.contains("hide")) {
						ccObject.Address = addressMethods.GetNewBillingAddress();
					} else {
						ccObject.Address = addressMethods.GetExistingAddress("#divBillAddress", addressMethods.BillingAddressTypeId);
					}
					return ccObject;
				};

			return {
				SetPaymentMethod: setPaymentMethod,
				FillEditCCForm: fillEditCCForm,
				FillEnterCVVForm: fillEnterCVVForm,
				FillNewCCForm: fillNewCCForm,
				GetEditCC: getEditCC,
				GetExistingCC: getExistingCC
			};
		}()),

		formEvents = (function () {
			var isRegistered = document.getElementById("Cart_IsRegistered") ? document.getElementById("Cart_IsRegistered").value : "";
			var completeIcon = "<div class='textTeal'><svg height='25px' width='25px' aria-label='complete' role='img'><title>Complete</title><use href='/icons/iconLibrary.svg#svgIcon-checkMark'></use> </svg></div>";
			var loadingIcon = '<div id="checkoutLoading" class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';

			var showBusy = function (parentDiv) {
				var loadingHTML = '<div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div>';
				var newDiv = document.createElement("div");
				newDiv.id = "showLoading";
				newDiv.classList.add("spinner");
				newDiv.classList.add("clear");
				newDiv.setAttribute("role", "alert");
				newDiv.setAttribute("aria-atomic", "true");
				newDiv.setAttribute("aria-label", "Loading, please wait");
				newDiv.innerHTML = loadingHTML;
				parentDiv.appendChild(newDiv);
			},

				hideBusy = function () {
					if (document.getElementById("showLoading")) {
						document.getElementById("showLoading").parentNode.removeChild(document.getElementById("showLoading"));
					}
				},

				loadPage = function () {
					document.getElementById("loadPage").classList.remove("hide");
					document.getElementById("loadPage").querySelector(".busyIndicator").innerHTML = loadingIcon;
				},

				loadCoupon = function () {
					document.getElementById("loadSummaryBox").classList.remove("hide");
					document.getElementById("loadSummaryBox").querySelector(".busyIndicator").innerHTML = loadingIcon;
				},

				loadPayment = function () {
					document.getElementById("loadingStep3").classList.remove("hide");
					document.getElementById("loadingStep3").querySelector(".busyIndicator").innerHTML = loadingIcon;
				},

				hideLoadPage = function () {
					document.getElementById("loadPage").classList.add("hide");
					document.getElementById("loadPage").querySelector(".busyIndicator").innerHTML = "";
				},

				hideLoadCoupon = function () {
					document.getElementById("loadSummaryBox").classList.add("hide");
					document.getElementById("loadSummaryBox").querySelector(".busyIndicator").innerHTML = "";
				},

				hidePaymentLoad = function () {
					document.getElementById("loadingStep3").classList.add("hide");
					document.getElementById("loadingStep3").querySelector(".busyIndicator").innerHTML = "";
				},
				reloadPage = function () {
					location.reload();
				},

				checkCartHasCoupon = function () {
					if (document.getElementById("divShowCouponCodes")) {
						if (document.getElementById("divShowCouponCodes").classList.contains("hide") && document.getElementById("btnEnterCouponCode")) {
							document.getElementById("btnEnterCouponCode").classList.remove("hide");
						} else if (document.getElementById("btnEnterCouponCode")) {
							document.getElementById("btnEnterCouponCode").classList.add("hide");
						}
					}
				},

				updateHeaderCartSummary = function (data) {
					if (data.PartialView1) {
						document.querySelector(".cartSummaryContainer").innerHTML = data.PartialView1;

						// re-hookup hover event -- currently in header2018.js
						var headerLinks = new header4i();
						headerLinks.HeaderCart.Init();
					}
				},

				showDetailsPopup = function (element) {
					removeDetailsPopup();
					element.setAttribute("aria-expanded", "true");

					var clickPos = element.getBoundingClientRect();
					var pageWidth = document.innerWidth;
					var top = clickPos.top + 12;
					var left = clickPos.left > 200 ? clickPos.left - 200 : clickPos.left;

					// check if on mobile device and adjust
					// 310 is the windows width
					var divWidth = 310;
					if (pageWidth - left < divWidth) {
						left = (pageWidth - divWidth) / 2;
					}

					element.insertAdjacentHTML('afterend', '<div id="cartDetailsPopup" class="cartDetailsPopup animate animateFast animateFadeIn bkgdWhite borderDkGray textLeft" data-focus-back="' + element.id + '" role="dialog"></div>');
					document.getElementById('cartDetailsPopup').innerHTML = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
					document.getElementById('cartDetailsPopup').style.position = "absolute";
					document.getElementById('cartDetailsPopup').style.left = left >= 0 ? left : 0;
					document.getElementById('cartDetailsPopup').style.top = top;
					ajaxActions.GetExtraDetails(element);
				},

				showAddCC = function () {
					document.getElementById('addCCCard').classList.remove("hide");
				},

				showPaymentOptions = function (payid) {
					if (payid == 'ccpayopt') {
						formEvents.ShowPaymentMethodPanel();
						document.getElementById('divOtherPayOptions').classList.add('hide');
					} else {
						document.getElementById('divCCPayOptions').classList.add('hide');
						document.getElementById('divOtherPayOptions').classList.remove('hide');
						document.getElementById('divNewPaymentMethod').classList.add('hide');
					}
				},

				showLineOfCreditInfo = function (e) {
					e.preventDefault();
					document.getElementById('divBillMeBtn').classList.add('hide');
					document.getElementById('divBillMeInfo').classList.remove('hide');
				},

				resetBillMeLater = function () {
					document.getElementById('divBillMeBtn').classList.remove('hide');
					document.getElementById('divBillMeInfo').classList.add('hide');
				},

				removeDetailsPopup = function () {
					var popup = document.getElementById('cartDetailsPopup');
					popup.parentNode.removeChild(popup);
					triggerEl.setAttribute("aria-expanded", "false");
					triggerEl.focus();
				},

				updateDetailsPopup = function (data) {
					var popup = document.getElementById('cartDetailsPopup');
					popup.innerHTML = data;
					popup.querySelector('.closeDetailsPopup').focus();

					document.querySelector(".closeDetailsPopup").addEventListener("click", function (e) {
						e.preventDefault();
						formEvents.RemoveDetailsPopup();
					});
					//trap focus
					document.querySelector(".closeDetailsPopup").addEventListener("keydown", function (e) {
						if (e.which == 9) {
							e.preventDefault();
							e.stopPropagation();
							this.focus();
						}
					});
				},

				updateCartTotals = function (data) {
					document.querySelector(".cartItemCount").innerHTML = data.ItemCount;
					document.querySelector(".cartSubtotal").innerHTML = data.SubTotal;
					document.querySelector(".cartFreightTotal").innerHTML = data.TotalFreight;
					document.querySelector(".cartTax").innerHTML = data.Tax;
					document.querySelector(".cartTotal").innerHTML = data.CartTotal;
					document.getElementById("couponDiscountAmount").innerHTML = data.CouponTotal;
				},

				showAjaxMessage = function (msg) {
					if (msg === undefined) {
						msg = "We're sorry, an error has occurred.  Please refresh the page and try again.";
					}
					document.getElementById("divNotification").innerHTML = msg;
					document.getElementById("divNotification").classList.remove("hide");
					document.getElementById("divNotification").focus();
					window.scrollTo({ top: 0, behavior: "smooth" });
				},

				hideAjaxMessage = function () {
					document.getElementById("divNotification").classList.add("hide");
				},

				markPaymentMethodComplete = function () {
					document.getElementById("editPaymentMethod").classList.remove("hide");
					document.getElementById("paymentMethodStatus").innerHTML = completeIcon;
					document.getElementById("paymentMethodStatus").classList.remove("textBlue");
					document.getElementById("paymentMethodStatus").classList.add("textTeal");
				},

				paymentMethodEditingMode = function () {
					var hiddenBills;
					if (paymentMethodEditMode) {
						document.getElementById("divSelectPaymentMethod").classList.add("hide");
						document.getElementById("divListPaymentMethod").classList.remove("hide");
						var payMethodRadios = [].slice.call(document.getElementById("divListPaymentMethod").querySelectorAll('input[type=radio]'));
						var selectedMethods = [];
						payMethodRadios.forEach(function (el, index, array) {
							if (el.checked) {
								selectedMethods.push(el);
							}
						});
						selectedMethods[0].focus();
						formEvents.ShowPaymentMethodPanel();
						if (document.getElementById("otherpayopt").checked == true) {
							document.getElementById("divNewPaymentMethod").classList.add("hide");
							document.getElementById("divCCPayOptions").classList.add("hide");
						}
						hiddenBills = [].slice.call(document.querySelectorAll(".hiddenpaybill"));
						hiddenBills.forEach(function (el, index, array) {
							el.classList.add("hide");
						});
						clearPaymentMethodError();
						removePaymentMethodError();
						closeOpenEdits();
					} else {
						// these are generally for when it is a first time user
						if (document.getElementById('divSelectPaymentMethod').innerHTML.trim().length !== 0) {
							var panel = document.getElementById('ccPayInfo');
							var creditCard = panel ? paymentMethods.GetExistingCC(panel, true) : undefined;

							if (!creditCard || verifyCreditCardAuthorized(creditCard)) {
								document.getElementById("divSelectPaymentMethod").classList.remove("hide");
								hiddenBills = [].slice.call(document.getElementById("divSelectPaymentMethod").querySelectorAll(".hiddenpaybill"));
								hiddenBills.forEach(function (el, index, array) {
									el.classList.remove("hide");
								});
								document.getElementById("divListPaymentMethod").classList.add("hide");
								document.getElementById("divNewPaymentMethod").classList.add("hide");
								closeOpenEditsCC();
							} else {
								paymentMethodEditMode = true;
								paymentMethodEditingMode();
								return;
							}
						} else {
							var numberOfCCs = document.getElementById("PaymentMethods_Count") ? document.getElementById("PaymentMethods_Count").value : document.getElementById("PaymentMethods_Count").value;

							if (parseInt(numberOfCCs) === 0) {
								document.getElementById('divCCPayOptions').classList.add('hide');
								document.getElementById("divNewPaymentMethod").classList.remove("hide");
							} else {
								document.getElementById("divNewPaymentMethod").classList.add("hide");
								document.getElementById("divCCPayOptions").classList.remove('hide');
							}

							document.getElementById("divListPaymentMethod").classList.remove('hide');
						}
					}
				},

				paymentMethodDefaultMode = function () {
					document.getElementById("divSelectPaymentMethod").classList.remove("hide");
					var hiddenBills = [].slice.call(document.getElementById("divSelectPaymentMethod").querySelectorAll(".hiddenpaybill"));
					hiddenBills.forEach(function (el, index, array) {
						el.classList.remove("hide");
					});
					document.getElementById("divListPaymentMethod").classList.add("hide");
					document.getElementById("editPaymentMethod").focus();
					document.getElementById("editPaymentMethod").scrollIntoView({ top: 0, behavior: "smooth" });
					closeOpenEditsCC();
				},

				displaySuccessPage = function (successPanel, userIsRegistered) {
					document.getElementById('cartPanel').innerHTML = successPanel;
					document.getElementById("loginPanel").classList.add("invisible"); // hide until it is styled
					window.scrollTo({ top: 0, behavior: "smooth" });
					document.getElementById('summaryPanel').classList.add('hide');
					if (userIsRegistered) {
						document.getElementById('loginPanel').classList.add('hide');
					}
				},

				updatePaymentMethods = function (ccList, message) {
					// update address list first before updating selected address
					document.getElementById("divListPaymentMethod").innerHTML = ccList;
					bindPaymentMethodEvents();
					confirmDeleteDialog.BindTriggerElements([].slice.call(document.querySelectorAll(".btnDeleteCC")));
					document.getElementById("divSelectPaymentMethod").innerHTML = message;
					paymentMethodEditMode = false;
					paymentMethodDefaultMode();
				},

				updateCvv = function (cardId, cvv) {
					var a = document.getElementById("divPaymentMethod_" + cardId).querySelectorAll("p");
					if (a.length > 5) {
						a[5].textContent = cvv;
					}

					a = document.getElementById("ccPayInfo").querySelectorAll("p");
					if (a.length > 5) {
						a[5].textContent = cvv;
					}
				},

				updatePaymentMethodInvoice = function () {
					document.getElementById("divSelectPaymentMethod").innerHTML = jsMessages.invoicePaymentLabel;
					paymentMethodEditMode = false;
					paymentMethodDefaultMode();
				},

				getCCCardId = function (cardId) {
					if (cardId.trim().length !== 0) {
						return cardId;
					}

					var div = document.getElementById("divListPaymentMethod").querySelectorAll(".selected");
					if (div.length) {
						var ids = div.id.split("_");

						if (ids.length === 2) {
							return ids[1];
						}
					}
					return "";
				},

				clearPaymentMethodError = function () {
					if (document.getElementById("divCCPayOptions").querySelector(".infoTextMainCC")) {
						document.getElementById("divCCPayOptions").querySelector(".infoTextMainCC").innerHTML = "";
					}
				},

				settingPaymentMethodError = function (msg) {
					if (document.getElementById("divCCPayOptions").querySelector(".infoTextMainCC")) {
						document.getElementById("divCCPayOptions").querySelector(".infoTextMainCC").innerHTML = msg;
						document.getElementById("divCCPayOptions").scrollIntoView({ top: 0, behavior: "smooth" });
					}
				},

				bindPaymentMethodEvents = function () {
					var paymentOpts = [].slice.call(document.querySelectorAll("input[name='payoptions']"));
					paymentOpts.forEach(function (el, index, array) {
						el.addEventListener("click", function (e) {
							formEvents.ShowPaymentOptions(el.id);
						});
					});

					var payWithCC = function (e) {
						e.preventDefault();
						formEvents.ResetBillMeLater();
						document.getElementById("ccpayopt").click();
					};
					if (document.getElementById("btnLOCPayWithCC")) {
						document.getElementById("btnLOCPayWithCC").removeEventListener("click", payWithCC);
						document.getElementById("btnLOCPayWithCC").addEventListener("click", payWithCC);
					}

					var proceed = function (e) {
						e.preventDefault();
						document.getElementById("divNewPaymentMethod").classList.add("hide");
						document.getElementById("divCCPayOptions").classList.add("hide");
						ajaxActions.SetPaymentMethodInvoice();
					};
					if (document.getElementById('btnProceed')) {
						document.getElementById('btnProceed').removeEventListener("click", proceed);
						document.getElementById('btnProceed').addEventListener("click", proceed);
					}

					var addCC = function (e) {
						e.preventDefault();
						forms.ClearValidation();
						if (!document.getElementById('divNewPaymentMethod').classList.contains('hide')) {
							document.getElementById('divNewPaymentMethod').classList.add('hide');
						} else {
							document.getElementById("divNewPaymentMethod").classList.remove("hide");
							formEvents.NewCreditCard(document.getElementById("btnAddCC"));
						}
					};

					if (document.getElementById("btnAddCC")) {
						document.getElementById("btnAddCC").removeEventListener("click", addCC);
						document.getElementById("btnAddCC").addEventListener("click", addCC);
					}
					var usePayment = function (e) {
						e.preventDefault();
						var el = e.currentTarget;
						showBusy(el.parentNode);
						toggleCCBtns(true);
						closeOpenEditsCC();
						var cardId = el.getAttribute("data-card-id");
						forms.ClearValidation();
						formEvents.EnterCVV(cardId);
					};
					var useCCBtns = [].slice.call(document.querySelectorAll(".btnUsePaymentMethod"));
					useCCBtns.forEach(function (el, index, array) {
						el.removeEventListener("click", usePayment);
						el.addEventListener("click", usePayment);
					});

					var editCC = function (e) {
						e.preventDefault();
						var el = e.currentTarget;
						toggleCCBtns(true);
						closeOpenEditsCC();
						forms.ClearValidation();
						formEvents.EditCreditCard(el);
					};
					var editCCBtns = [].slice.call(document.querySelectorAll(".btnEditCC"));
					editCCBtns.forEach(function (el, index, array) {
						el.removeEventListener("click", editCC);
						el.addEventListener("click", editCC);
					});

					if (document.getElementById('btnBillMe')) {
						document.getElementById('btnBillMe').addEventListener("click", formEvents.ShowLineOfCreditInfo);
					}
				},

				toggleCCBtns = function (disabledStatus) {
					var editBtns = [].slice.call(document.querySelectorAll(".btnEditCC"));
					editBtns.forEach(function (elem, index, array) {
						elem.disabled = disabledStatus;
					});
					var usePmtMethod = [].slice.call(document.querySelectorAll(".btnUsePaymentMethod"));
					usePmtMethod.forEach(function (elem, index, array) {
						elem.disabled = disabledStatus;
					});
					var deleteBtns = [].slice.call(document.querySelectorAll(".btnDeleteCC"));
					deleteBtns.forEach(function (elem, index, array) {
						elem.disabled = disabledStatus;
					});
					document.getElementById("btnAddCC").disabled = disabledStatus;
				},

				removeCreditCard = function (id) {
					clearPaymentMethodError();
					document.getElementById("divPaymentMethod_" + id).parentNode.parentNode.removeChild(document.getElementById("divPaymentMethod_" + id).parentNode);
					if (document.getElementById("divSelectPaymentMethod").querySelector("p")) {
						if (document.getElementById("divSelectPaymentMethod").querySelector("p").textContent === id)
							document.getElementById("divSelectPaymentMethod").innerHTML = "";
					}
					document.getElementById("btnAddCC").focus();
					document.getElementById("btnAddCC").scrollIntoView({ top: 0, behavior: "smooth" });
				},

				deleteConfirmed = function () {
					if (document.getElementById("popUpDialog").getAttribute("data-delete-type") === "CC") {
						ajaxActions.DeleteCC(document.getElementById("popUpDialog").getAttribute("data-card-id"));
					}
				},

				checkIfSmallScreen = function () {
					if (windowWidth < 800) {
						accordions.openAll(document.getElementById("mainContent"));
					}
				},

				disabledRequiredFields = function () {
					//hide and disable the validation for the following fields
					document.getElementById('divCardName').classList.add('hide');
					document.getElementById("CardName").classList.remove('txtReq');

					document.getElementById('divCardNumber').classList.add('hide');
					document.getElementById("CardNumber").classList.remove('txtReq');

					document.getElementById('divCardExpiration').classList.add('hide');
					document.getElementById("CardExpirationMonth").classList.remove('txtReq');
					document.getElementById("CardExpirationYear").classList.remove('txtReq');

					document.getElementById('divCardIsSaved').classList.add('hide');
					document.getElementById('divCardIsDefault').classList.add('hide');
				},

				enterCVV = function (cardId) {
					clearPaymentMethodError();
					closeOpenEditsCC();

					//insert the CSS triangle
					document.getElementById("divPaymentMethod_" + cardId).parentNode.classList.add("editCreditJS");
					document.getElementById("divPaymentMethod_" + cardId).parentNode.classList.remove("borderBottomMdGray");
					document.getElementById("divNewPaymentMethod").classList.add("hide");
					var setUpCCForm = function () {
						hideBusy();

						var hideItems = [].slice.call(document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelectorAll(".hideCCItem"));
						hideItems.forEach(function (el, index, array) {
							el.classList.add("invisible");
						});
						toggleCCBtns(false);
						document.getElementById("divEditCC_" + cardId).querySelector("input").focus();
						document.getElementById("divEditCC_" + cardId).scrollIntoView({ top: 0, behavior: "smooth" });

						disabledRequiredFields();
						document.getElementById('fsBillingAddress').classList.add('hide');
						document.getElementById('divSaveCreditCard').classList.remove('hide');
						if (document.getElementById("CardCCV").type != "hidden") {
							document.getElementById("divEditCC_" + cardId).querySelectorAll(".formHeading")[1].textContent = document.getElementById("LabelEnterCVV").value;
						} else {
							document.getElementById("divCreditCardFormBlock").classList.add("hide");
							document.getElementById('IsSaved').checked = false;
							document.getElementById('SavedName').classList.remove("txtReq");
						}

						paymentMethods.FillEnterCVVForm(cardId);
						formEvents.RemoveCardNumberSpaces(document.getElementById("divEditCC_" + cardId));
						document.getElementById("btnAddCC").parentNode.classList.add('hide');
						tooltips.init();
						document.getElementById("btnSaveCreditCard").addEventListener("click", function (e) {
							e.preventDefault();
							forms.ClearValidation();
							forms.formValidation(document.getElementById("divCreditCardFormBlock"), function () {
								forms.ClearValidation();
								forms.formValidation(document.getElementById("emailFormBlock"), function () { savePaymentMethod(cardId); }, e);
							}, e);
						});

						document.getElementById("btnCancelSaveCreditCard").addEventListener("click", function (e) {
							e.preventDefault();
							cancelEditCC(this);
						});

						document.getElementById("SavedName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });
						document.getElementById("CardName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });

					};
					ajaxActions.GetCCForm(document.getElementById("divEditCC_" + cardId), setUpCCForm);
				},

				editCreditCard = function (element) {
					showBusy(element.parentNode);
					clearPaymentMethodError();

					var cardId = element.getAttribute("data-card-id");
					//insert the CSS triangle
					document.getElementById("divPaymentMethod_" + cardId).parentNode.classList.add("editCreditJS");
					document.getElementById("divPaymentMethod_" + cardId).parentNode.classList.remove("borderBottomMdGray");

					var setUpCCForm = function () {
						hideBusy();
						var hideItems = [].slice.call(document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelectorAll(".hideCCItem"));
						hideItems.forEach(function (el, index, array) {
							el.classList.add("invisible");
						});
						toggleCCBtns(false);
						document.getElementById("divEditCC_" + cardId).querySelector("input").focus();
						document.getElementById("divEditCC_" + cardId).scrollIntoView({ top: 0, behavior: "smooth" });

						document.getElementById("divEditCC_" + cardId).querySelectorAll(".formHeading")[1].textContent = document.getElementById("LabelEditCC").value;
						document.getElementById("divEditCC_" + cardId).querySelectorAll(".formHeading")[2].textContent = document.getElementById("LabelChangeBillingAddress").value;
						document.getElementById("btnSaveCreditCard").value = document.getElementById("LabelEditCCSave").value;
						document.getElementById("fsBillingAddress").querySelectorAll(".formHeading")[0].textContent = document.getElementById("LabelBillingAddress").value;
						document.getElementById("divBillAddress").classList.remove('hide');

						document.getElementById("divSaveCreditCard").classList.remove('hide');
						document.getElementById("btnAddCC").parentNode.classList.add('hide');

						// need to update billing 
						if (updatedBillingAddresses) { formEvents.UpdateBillingAddressList(updatedBillingAddresses); }
						bindBillingAddressEvents();

						paymentMethods.FillEditCCForm(cardId);
						formEvents.RemoveCardNumberSpaces(document.getElementById("divEditCC_" + cardId));

						document.getElementById("btnSaveCreditCard").addEventListener("click", function (e) {
							e.preventDefault();
							forms.ClearValidation();
							if (document.getElementById("divAddBillAddress").classList.contains("hide")) {
								forms.formValidation(document.getElementById("divCreditCardFormBlock"), function () {
									forms.ClearValidation();
									forms.formValidation(document.getElementById("emailFormBlock"), function () { savePaymentMethod(cardId); }, e);
								}, e);
							}
							else {
								forms.formValidation(document.getElementById("divListPaymentMethod"), function () {
									forms.ClearValidation();
									forms.formValidation(document.getElementById("emailFormBlock"), function () { savePaymentMethod(cardId); }, e);
								}, e);
							}
						});

						document.getElementById("btnCancelSaveCreditCard").addEventListener("click", function (e) {
							e.preventDefault();
							cancelEditCC(this);
						});

						document.getElementById("SavedName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });
						document.getElementById("CardName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });
					};
					ajaxActions.GetCCForm(document.getElementById("divEditCC_" + cardId), setUpCCForm);
				},

				closeOpenEditsCC = function () {
					var divs = document.querySelectorAll("[id^='divEditCC_']");

					for (var i = 0; i < divs.length; i++) {
						var el = divs[i];
						if (el.innerHTML.length > 0) {
							el.innerHTML = "";
							var id = el.id.split("_");

							if (id.length === 2) {
								resetDivPaymentMethod(id[1]);
							}
						}
					}
					resetAddCC();
				},

				resetAddCC = function () {
					var div = document.getElementById("divAddCCForm");
					if (div.innerHTML !== undefined) {
						if (div.innerHTML.length > 0) {
							div.innerHTML = "";
							document.getElementById("btnAddCC").parentNode.classList.remove("hide");
							document.getElementById("btnAddCC").focus();
						}
					}
					document.getElementById("divNewCCholder").innerHTML = "";
				},

				cancelEditCC = function (element) {
					var cardID = document.getElementById("CardID").value;
					toggleCCBtns(false);
					if (cardID.trim().length !== 0) {
						resetDivPaymentMethod(cardID);
						document.getElementById("divEditCC_" + cardID).innerHTML = "";
					} else {
						resetAddCC();
					}
					document.getElementById("btnAddCC").parentNode.classList.remove('hide');
				},

				savePaymentMethod = function (cardId, newCustomer) {
					formEvents.LoadPayment();
					var cCard = paymentMethods.GetEditCC(cardId, newCustomer);
					cCard.PaymentTypeID = forms.GetPaymentTypeID(creditCardIds, cCard.CardNumber, cCard.PaymentTypeID);
					cCard.PaymentID = document.getElementById("Cart_UserCart_PymtMethod_PaymentId").value;
					ajaxActions.SavePaymentMethod(cCard);
				},

				newCreditCard = function (element) {
					if (!document.getElementById("divNewPaymentMethod").classList.contains("hide")) {
						loadPayment();
						closeOpenEditsCC();
						var setUpNewCCForm = function () {
							hideBusy();
							hidePaymentLoad();
							document.getElementById("divNewCCholder").querySelectorAll(".formHeading")[1].textContent = document.getElementById("LabelEnterCC").value;
							document.getElementById("divNewCCholder").querySelectorAll(".formHeading")[2].textContent = document.getElementById("LabelEnterBillingAddress").value;
							paymentMethods.FillNewCCForm();

							if (updatedBillingAddresses) { formEvents.UpdateBillingAddressList(updatedBillingAddresses); }
							bindBillingAddressEvents();

							var numberOfCCs = document.getElementById("PaymentMethods_Count") ? document.getElementById("PaymentMethods_Count").value : document.getElementById("PaymentMethods_Count").value;
							if (document.getElementById("Cart_IsRegistered").value == "False") {
								document.getElementById("divCardIsSaved").classList.add('hide');
								document.getElementById("divCardIsDefault").classList.add('hide');
								document.getElementById("btnCancelSaveCreditCard").classList.add('hide');
							} else if (parseInt(numberOfCCs) === 0) {
								document.getElementById("btnCancelSaveCreditCard").classList.add('hide');
								document.getElementById('btnAddCC').parentNode.classList.add('hide');
							} else {
								document.getElementById('btnAddCC').parentNode.classList.add('hide');
							}

							document.getElementById("btnNewBillAddress").click();
							document.getElementById("fsBillingAddress").classList.add('hide');
							document.getElementById("divSaveCreditCard").classList.remove("hide");
							document.getElementById("divAddressFormBlock").querySelectorAll(".formHeading")[1].textContent = 'Billing Address';
							document.getElementById("btnCancelSaveCreditCard").setAttribute("title", document.getElementById("LabelCancelAddCC").value);
							document.getElementById("btnCancelSaveCreditCard").setAttribute("aria-label", document.getElementById("LabelCancelAddCC").value);

							document.getElementById("IsSaved").addEventListener("change", function () {
								forms.ShowSaveCardName(document.getElementById("IsSaved"), document.getElementById("SavedName"), document.getElementById("IsDefault"));
							});

							document.getElementById("btnSaveCreditCard").addEventListener("click", function (e) {
								e.preventDefault();
								forms.ClearValidation();
								forms.UnmaskCCNumber(document.getElementById("CardNumber"));
								if (document.getElementById('Cart_IsRegistered').value != "True") {
									document.getElementById('SavedName').classList.remove('txtReq');
								}
								forms.formValidation(document.getElementById("divNewCCholder"), function () {
									forms.ClearValidation();
									forms.formValidation(document.getElementById("emailFormBlock"), function () { savePaymentMethod("", false); }, e);
								}, e);

								forms.MaskCCNumber(document.getElementById('CreditCardMask'), document.getElementById('CardNumber'));
							});

							document.getElementById("btnCancelSaveCreditCard").addEventListener("click", function (e) {
								e.preventDefault();
								document.getElementById('divNewPaymentMethod').classList.add('hide');
								if (document.getElementById('Cart_IsRegistered').value == "True") {
									document.getElementById('btnAddCC').parentNode.classList.remove('hide');
								}
							});

							document.getElementById("SavedName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });
							document.getElementById("CardName").addEventListener('blur', function (e) { e.target.value = forms.VerifyName(e.target.value); });

							if (document.getElementById('CardNumber')) {
								forms.MaskCCNumber(document.getElementById('CreditCardMask'), document.getElementById('CardNumber'));
							}
							document.getElementById('CardNumber').addEventListener('keyup', function () {
								var FirstCardDigit = document.getElementById('CardNumber').value.substring(0, 1);
								forms.FadeCCImgs(document.getElementById('CardNumber'), document.getElementById('btnSaveCreditCard'), document.getElementById("SavedName"));

								switch (FirstCardDigit) {
									case "3":
										document.getElementById("PaymentTypeID").value = 5;
										document.getElementById("PaymentTypeID").setAttribute('selected', true);
										break;
									case "4":
										document.getElementById("PaymentTypeID").value = 3;
										document.getElementById("PaymentTypeID").setAttribute('selected', true);
										break;
									case "2":
									case "5":
										document.getElementById("PaymentTypeID").value = 4;
										document.getElementById("PaymentTypeID").setAttribute('selected', true);
										break;
									case "6":
										document.getElementById("PaymentTypeID").value = 10;
										document.getElementById("PaymentTypeID").setAttribute('selected', true);
										break;
									default:
										return false;
								}
							});
							// prevent focus shift if this is the first time they are loading the page
							if (document.getElementById("editShippingAddress") !== document.activeElement) {
								document.getElementById("CardName").focus();
							}
						};
						// get the form, put it in this container, execute this function
						ajaxActions.GetCCForm(document.getElementById("divNewCCholder"), setUpNewCCForm);
					}
				},

				resetDivPaymentMethod = function (cardId) {
					//remove the CSS triangle
					document.getElementById("divPaymentMethod_" + cardId).scrollIntoView({ top: 0, behavior: "smooth" });
					document.getElementById("divPaymentMethod_" + cardId).parentNode.classList.remove("editCreditJS");
					document.getElementById("divPaymentMethod_" + cardId).parentNode.classList.add("borderBottomMdGray");
					var hideItems = [].slice.call(document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelectorAll(".hideCCItem"));
					hideItems.forEach(function (el, index, array) {
						el.classList.remove("invisible");
					});
					document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelector(".btnEditCC").focus();
				},

				bindBillingAddressListEvents = function () {
					document.getElementById("btnCancelSelectBillingAddress").addEventListener("click", function (e) {
						document.getElementById("divSelectBillAddress").classList.add("hide");
						if (!document.getElementById("divBillAddress").classList.contains("hide")) {
							document.getElementById("divSaveCreditCard").classList.remove("hide");
						}
						document.getElementById("btnSelectBillAddress").focus();
					});

					var useAddyBtns = [].slice.call(document.querySelectorAll(".btnUseBillAddress"));
					useAddyBtns.forEach(function (el, index, array) {
						el.addEventListener("click", function (e) {
							addressMethods.SelectBillingAddress(document.getElementById(el.getAttribute("aria-describedby")));
							showSelectedBilling();
						});
					});
				},

				bindBillingAddressEvents = function () {
					document.getElementById("btnSelectBillAddress").addEventListener("click", function (e) {
						e.preventDefault();
						forms.ClearValidation();
						if (document.getElementById("divSelectBillAddress").classList.contains("hide")) {
							document.getElementById("divAddBillAddress").classList.add("hide");
							document.getElementById("divSelectBillAddress").classList.remove("hide");
							document.getElementById("divSelectBillAddress").querySelector(".btnUseBillAddress").focus();
							document.getElementById("divSaveCreditCard").classList.add("hide");
						} else {
							document.getElementById("divSelectBillAddress").classList.add("hide");
							if (!document.getElementById("divBillAddress").classList.contains("hide")) {
								document.getElementById("divSaveCreditCard").classList.remove("hide");
							}
						}
					});

					document.getElementById("btnNewBillAddress").addEventListener("click", function (e) {
						e.preventDefault();
						document.getElementById("divBillAddress").classList.add("hide");
						document.getElementById("btnSaveCreditCard").classList.remove("hide");
						document.getElementById("divSaveCreditCard").classList.remove("hide");
						if (displayBillAddressForm()) {
							document.getElementById("AddressId").value = "";
							document.getElementById("FirstName").focus();
						}
					});

					bindBillingAddressListEvents();
				},

				displayBillAddressForm = function () {
					if (document.getElementById("divAddBillAddress").classList.contains("hide")) {
						document.getElementById("divAddBillAddress").classList.remove("hide");
						document.getElementById("divAddBillAddress").querySelectorAll(".formHeading")[1].textContent = document.getElementById("LabelAddAddress").value;
						document.getElementById("Phone").addEventListener("keydown", function (e) {
							if (e.key === "Enter") {
								e.preventDefault();
								document.getElementById("btnSaveCreditCard").click();
							}
						});
						document.getElementById("divSelectBillAddress").classList.add("hide");
						document.getElementById("divAddressDefault").classList.add("hide");
						document.getElementById("divSaveAddressBtn").classList.add("hide");
						document.getElementById("divSaveAddressBtn").classList.remove("inlineMiddle");
						return true;
					} else {
						document.getElementById("divAddBillAddress").classList.add("hide");
						if (!document.getElementById("divBillAddress").classList.contains("hide")) {
							document.getElementById("divSaveCreditCard").classList.remove("hide");
						}
						return false;
					}
				},

				displayEditBillAddressForm = function () {
					// billing address form should be hidden
					if (!displayBillAddressForm()) {
						displayBillAddressForm();
					}

					document.getElementById("divAddBillAddress").querySelectorAll(".formHeading")[1].textContent = document.getElementById("LabelEditAddress").value;
					addressMethods.FillEditBillingAddress();
				},

				showSelectedBilling = function () {
					document.getElementById("fsBillingAddress").classList.remove("hide");
					document.getElementById("divBillAddress").classList.remove("hide");
					document.getElementById("divSelectBillAddress").classList.add("hide");
					document.getElementById("divAddBillAddress").classList.add("hide");
					document.getElementById("divSaveCreditCard").classList.remove("hide");
					document.getElementById("btnSaveCreditCard").focus();
					document.getElementById("btnSaveCreditCard").scrollIntoView({ top: 0, behavior: "smooth" });
				},

				hideSelectedBilling = function () {
					document.getElementById("divBillAddress").classList.add("hide");
					document.getElementById("divSaveCreditCard").classList.add("hide");
				},

				removeCardNumberSpaces = function (element) {
					var cardNumber = element.querySelector("#CardNumber");
					cardNumber.value = cardNumber.value.replace(/\s+/g, '');
				},

				removePaymentMethodError = function () {
					document.querySelector(".infoTextCC").innerHTML = "";
				},

				showPaymentMethodPanel = function () {
					var numberOfCCs = document.getElementById("PaymentMethods_Count") ? document.getElementById("PaymentMethods_Count").value : document.getElementById("PaymentMethods_Count").value;
					if (parseInt(numberOfCCs) === 0) {
						document.getElementById('divCCPayOptions').classList.add('hide');
						document.getElementById("divNewPaymentMethod").classList.remove("hide");
						formEvents.NewCreditCard();
					} else {
						document.getElementById("divNewPaymentMethod").classList.add("hide");
						document.getElementById('divCCPayOptions').classList.remove('hide');
					}
				},

				updateBillingAddressList = function (addressList) {
					if (document.getElementById("divSelectBillAddress")) {
						document.getElementById("divSelectBillAddress").innerHTML = addressList;
					}
				},

				verifyCreditCardAuthorized = function (creditCard) {
					return creditCard.IsAuthorized || !!creditCard.CardCCV;
				},

				putCreditCardInEditMode = function (cardId, editPaymentMethod) {
					var putInEdit = function () {
						if (editPaymentMethod) {
							paymentMethodEditMode = true;
							document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelector(".btnEditCC").click();
						} else {
							document.getElementById("divPaymentMethod_" + cardId).parentNode.querySelector(".btnEditCC").click();
							document.getElementById("btnSaveCreditCard").click();
						}
					};
					// get the form, put it in this container, execute this function
					ajaxActions.GetCCForm("", putInEdit);
				},

				setRegisterUserForm = function () {
					if (document.getElementById("Cart_UserCart_OasisOrderID").value > 0) {
						if (document.getElementById('Cart_IsRegistered').value == "True") {
							RegistrationForm.SetForm_UserIsRegistered();
						} else {
							RegistrationForm.SetForm_SignIn();
						}
					}
				},

				showAuthenticationError = function (message) {
					if (window.appInsights) appInsights.trackTrace({ message: "Authentication error orderId: " + document.getElementById("UserCart_OrderGuid").value + " message: " + message });
					hideBusy();
					hideLoadPage();
					hidePaymentLoad();
					showAjaxMessage(jsMessages.authenticationError);
				};

			return {
				ShowAjaxMessage: showAjaxMessage,
				HideAjaxMessage: hideAjaxMessage,
				LoadPage: loadPage,
				HideBusy: hideBusy,
				ShowBusy: showBusy,
				HideLoadPage: hideLoadPage,
				LoadCoupon: loadCoupon,
				HideLoadCoupon: hideLoadCoupon,
				LoadPayment: loadPayment,
				HidePaymentLoad: hidePaymentLoad,
				ReloadPage: reloadPage,
				RemoveDetailsPopup: removeDetailsPopup,
				ShowDetailsPopup: showDetailsPopup,
				ShowPaymentOptions: showPaymentOptions,
				ShowLineOfCreditInfo: showLineOfCreditInfo,
				UpdateDetailsPopup: updateDetailsPopup,
				UpdateCartTotals: updateCartTotals,
				DeleteConfirmed: deleteConfirmed,
				PaymentMethodDefaultMode: paymentMethodDefaultMode,
				PaymentMethodEditingMode: paymentMethodEditingMode,
				UpdatePaymentMethods: updatePaymentMethods,
				UpdateCvv: updateCvv,
				ClearPaymentMethodError: clearPaymentMethodError,
				SettingPaymentMethodError: settingPaymentMethodError,
				ResetBillMeLater: resetBillMeLater,
				RemoveCreditCard: removeCreditCard,
				UpdatePaymentMethodInvoice: updatePaymentMethodInvoice,
				EditCreditCard: editCreditCard,
				EnterCVV: enterCVV,
				NewCreditCard: newCreditCard,
				ResetDivPaymentMethod: resetDivPaymentMethod,
				HideSelectedBilling: hideSelectedBilling,
				ShowSelectedBilling: showSelectedBilling,
				RemoveCardNumberSpaces: removeCardNumberSpaces,
				RemovePaymentMethodError: removePaymentMethodError,
				ShowPaymentMethodPanel: showPaymentMethodPanel,
				UpdateBillingAddressList: updateBillingAddressList,
				BindBillingAddressListEvents: bindBillingAddressListEvents,
				DisplayEditBillAddressForm: displayEditBillAddressForm,
				VerifyCreditCardAuthorized: verifyCreditCardAuthorized,
				PutCreditCardInEditMode: putCreditCardInEditMode,
				DisplaySuccessPage: displaySuccessPage,
				SetRegisterUserForm: setRegisterUserForm,
				CheckIfSmallScreen: checkIfSmallScreen,
				CheckCartHasCoupon: checkCartHasCoupon,
				BindPaymentMethodEvents: bindPaymentMethodEvents,
				ShowAuthenticationError: showAuthenticationError,
				CloseOpenEditsCC: closeOpenEditsCC
			};
		}());

	return {
		Init: init
	};
};

(function () {
	var paymentPage = new payment4i();
	paymentPage.Init();
})();